import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { LayoutService } from 'src/app/_services/app.layout.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    encapsulation: ViewEncapsulation.None
})

export class AppTopbarComponent {

    @ViewChild('menubutton') menuButton!: ElementRef;

    constructor(public layoutService: LayoutService,public globalservice: GlobalService) { }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }
    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }
    
}